import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const stylesBase = (theme: Theme) =>
  createStyles({
    appHeader: {
      flexDirection: 'column',
      // marginBottom: ({ matchLzPage }: { matchLzPage: boolean }) => (matchLzPage ? 84 : 32),
      // boxShadow: '0px 4px 24px rgba(227, 228, 236, 0.71)',
      // position: 'sticky',
      // top: '0',
      // zIndex: 2,
      position: 'sticky',
      top: 0,
      height: '100vh',
      maxWidth: 260,
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#fff',
      // width: '100%',
    },
    newDesignBtn: {
      position: 'sticky',
      bottom: 0,
      padding: '15px 24px',
      backgroundColor: '#333',
      width: '100%',
      borderRadius: 0,
      '&:hover': {
        backgroundColor: '#6366F1',
        color: theme.palette.common.white,
      },
    },
  });

export const useStyles = makeStyles(theme => ({
  ...stylesBase(theme),
}));
